// client/src/bids/BidList.tsx
import React, { Fragment, useCallback, SyntheticEvent } from 'react';
import {
    List, Datagrid, TextField, EditButton, NumberField,
    useListContext, TextInput, FunctionField, ListProps,
    DateInput
} from 'react-admin';
import { Tabs, Tab, useMediaQuery, Theme } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import useAdmin from '../hooks/useAdmin';
import useAuthorize from '../hooks/useAuthorize';
import { IBid } from '../types/types';
import { UserRole } from '../types/types';

// 🔹 Status tabs
const tabs = [
    { id: '1', name: 'Pending' },
    { id: '2', name: 'Approved' },
    { id: '3', name: 'Rejected' },
];

// 🔹 Search filters
const bidFilters = [
    <TextInput label="Customer Number" source="customer_contact" alwaysOn />,
    <TextInput label="Product Name" source="product_name" />,
    <DateInput label="Bid Date" source="bid_date" key="bid-date" />,
];

const TabbedDatagrid = () => {
    const { filterValues, setFilters, displayedFilters } = useListContext();
    const theme: Theme = useTheme();
    const isXSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();

    const handleChange = useCallback(
        (_event: SyntheticEvent, value: string) => {
            setFilters({ ...filterValues, status: value }, displayedFilters);
        },
        [filterValues, setFilters, displayedFilters]
    );

    useAuthorize([UserRole.Admin, UserRole.ProductAdmin]);

    return (
        <Fragment>
            <Tabs
                value={filterValues.status || '1'}
                onChange={handleChange}
                centered
                style={{ marginBottom: 10 }}
            >
                {tabs.map(choice => (
                    <Tab key={choice.id} label={choice.name} value={choice.id} />
                ))}
            </Tabs>

            <Datagrid>
                <NumberField source="id" label="ID" />
                <TextField source="bid_date" label="Bid Date" />
                <TextField source="customer_contact" label="Customer" />
                <TextField source="product_name" label="Product Name" />
                <TextField source="product_grade" label="Product Grade" />
                <TextField source="bid_city_name" label="Bid City" />
                <NumberField source="bid_price" label="Price" />
                <NumberField source="accepted_bid_quantity" label="Accepted Qty" />
                <NumberField source="accepted_bid_price" label="Accepted Price" />
                <NumberField source="bid_total" label="Total" />
                <TextField source="bid_order_id" label="Order ID" />
                <EditButton />
            </Datagrid>
        </Fragment>
    );
};

export const BidList = (props: ListProps) => (
    <List
        {...props}
        filters={bidFilters}
        filterDefaultValues={{ status: '1' }}
    >
        <TabbedDatagrid />
    </List>
);

export default BidList;
